import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';
import { TranslateConfigService } from 'src/app/core/services/translate-config.service';
import { UserTokenService } from 'src/app/core/services/user-token.service';
import { BreadcrumbService } from 'src/app/layout/topbar/app.breadcrumb.service';
import { ScUserMessageOutput } from 'src/app/models/response/sc-user.model';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';

@Component({
  selector: 'app-sc-user-message-list',
  templateUrl: './sc-user-message-list.component.html',
  styleUrls: ['./sc-user-message-list.component.scss']
})
export class ScUserMessageListComponent implements OnInit {

  public list: ScUserMessageOutput[] = [];
  public language: string = "pt-BR";

  public flUpdate: boolean = true;

  public message: string = "";
  public pageMessage: string = "";
  public classBtnUpd: string = "p-button p-button-success p-m-1 mr-1";
  public classBtnDel: string = "p-button p-button-danger p-m-1 mr-1";
  public classBtnReset: string = "p-button p-button-warning p-m-1 mr-1";

  constructor(private userService: ScUserService,
    private userTokenService: UserTokenService,
    //private notificationsService: NotificationsService,
    //private confirmationService: ConfirmationService,
    private translateService: TranslateService,
    private translateConfigService: TranslateConfigService,
    private breadcrumbService: BreadcrumbService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.language = this.translateConfigService.getLanguage();

    this.flUpdate = this.userTokenService.hasPermissionArray(['SF_ADMIN', 'SC_MANAGER_U']);

    if (this.flUpdate == false) {
      this.classBtnDel = this.classBtnReset = "p-button p-button-secondary p-m-1 mr-1";
    }

    this.getList();
  }

  translate() {
    const labAccessControl = this.translateService.instant('label.access_control') + " ";
    const labUser = " " + this.translateService.instant('label.users');
    this.breadcrumbService.setItems([{ label: labAccessControl }, { label: labUser, routerLink: ['user'] }]);

    this.pageMessage = this.translateService.instant('grid.showing') + " {first} " + this.translateService.instant('grid.to') + " {last} " + this.translateService.instant('grid.of') + " {totalRecords} " + this.translateService.instant('grid.entries')
  }

  getList() {
    let userId = this.userTokenService.getUserId();
    this.userService.getListUserMessage(`TargetUserId_SourceUserId = ${userId}`).subscribe(
      {
        next: (res) => {
          if (res)
            this.list = res.data;
          console.log(this.list);
          this.translate();
        },
        error: (err) => console.log(`UserGrid - getList : ${err}.`)
      });
  }

}